<template>
  <Teleport to="body">
    <div
      class="login-theme-toggle"
      :class="isDark ? 'login-theme-toggle--dark' : 'login-theme-toggle--light'"
      role="group"
      aria-label="Theme selection"
    >
      <button
        type="button"
        class="login-theme-toggle__btn"
        :class="{ 'login-theme-toggle__btn--active': !isDark }"
        aria-label="Switch to light theme"
        :aria-pressed="!isDark"
        @click="$emit('set-light')"
      >
        <v-icon icon="mdi-weather-sunny" size="18" />
      </button>
      <button
        type="button"
        class="login-theme-toggle__btn"
        :class="{ 'login-theme-toggle__btn--active': isDark }"
        aria-label="Switch to dark theme"
        :aria-pressed="isDark"
        @click="$emit('set-dark')"
      >
        <v-icon icon="mdi-weather-night" size="18" />
      </button>
    </div>
  </Teleport>
</template>

<script setup>
defineOptions({ name: 'LoginThemeToggle' })

defineProps({
  isDark: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['set-light', 'set-dark'])
</script>
